import { createContext } from "react";
import { StaffRole } from "../types/roles";

export type User = {
  uuid: string;
  avatar?: string;
  company: string;
  first_name: string;
  last_name: string;
  role: StaffRole;
  user_uuid: string;
  superuser: boolean;
  membershipStatus?:
    | "admin"
    | "coach"
    | "frontdesk"
    | "lead"
    | "member"
    | "non-member"
    | "ex-member"
    | string;
};

// This still partial, but working on finish all typing :)
export type Client = {
  addressLine1?: string;
  bankConnected?: 0 | 1;
  client_id: string | number;
  client_uuid: string;
  company: string;
  country: number;
  countryIso2: string;
  countryName: string;
  currency_iso?: string;
  currencyIso: string;
  email: string;
  externalUuid: string;
  gymType?: string;
  id: number;
  isMassEmailEnabled: boolean | number;
  join_timestamp?: number;
  joinTimestamp?: number;
  logoUrl?: string;
  planType?: "PRO" | "MAX" | "FREE";
  phone?: string;
  state?: string;
  stripeUserId?: string | null;
  subdomain: string;
  timezone: string;
  url?: string;
  uuid: string;
  websiteUrl?: string;
  clientSubtypeUuid?: string;
};

export type StripeConfig = {
  publishableKey: string;
};

export const AppContext = createContext({
  user: {},
  client: {},
  spa: false,
} as {
  user?: User;
  client: Client;
  spa: boolean;
  stripeConfig: StripeConfig;
});
